import cn from 'classnames';
import get from 'lodash/get';
import { Icon } from 'ht-styleguide';

/* Components */
import { ServiceUpsellPrice } from '@scenes/ServiceSkuPage/Parts/ServiceInfo/Parts/ServiceUpsellLabel';
import Either from '@components/Either';
import Maybe from '@components/Maybe';

/* Utils */
import { getAnnualAndMonthlySplitPlanPricing } from '@utils/plans';

/* Types */
import { TPlans, TPlansInfo } from 'types/plans.types';
import { Sku } from 'types/sku.types';

/* Styles & Constants */
import Benefits from '../Benefits';
import styles from './maincontent.module.scss';

type MainContentProps = {
  plan: TPlans;
  sku: Sku;
  plansInfo?: TPlansInfo;
};

const MainContent = ({ plan, sku, plansInfo }: MainContentProps) => {
  const upsellPlan = plansInfo?.monthly;
  const { amount: planCost } = upsellPlan || {};
  const planInterval = '/month';
  const planCostFormatted = `$${planCost}/month`;
  const { oldPrice, currentPrice, planPricingSplit } = getAnnualAndMonthlySplitPlanPricing(true);
  const splitPlanPricing = planPricingSplit ? (
    <>
      <ServiceUpsellPrice oldPrice={oldPrice} currentPrice={currentPrice} classes="lightBlue300" />
      {planInterval}
    </>
  ) : (
    planCostFormatted
  );

  // savings
  const { basePrice } = sku;
  const cheapestPrice = get(sku, 'subscriptionPrices.cheapestPrice', basePrice);
  const savings = basePrice - cheapestPrice;
  const savingsFormatted = `$${Math.ceil(savings / 100)}`;
  const description = sku.physicalProduct ? 'product' : 'service';

  return (
    <>
      <div className={cn('paddingY-medium1 paddingX-medium', styles.bannerWrapper)}>
        <section className={styles.banner}>
          <Icon name="logo-hellotech-home" className={styles.planName} />
          <Either condition={planPricingSplit}>
            <p className={cn('p1 text-weight-book white', styles.subHeader)}>{splitPlanPricing} Membership</p>
            <p className={cn('p1 text-weight-book white', styles.subHeader)}>Annual Membership for only {splitPlanPricing}</p>
          </Either>
        </section>
      </div>

      <section className={styles.mainContent}>
        <div className={styles.subHeaderWrapper}>
          <Maybe condition={savings > 0}>
            <h3 className={styles.savings}>
              <span className="lightBlue700">Save {savingsFormatted}</span> on this {description} and gain access to all of these benefits:
            </h3>
          </Maybe>
        </div>
        <Benefits plan={plan} plansInfo={plansInfo} />
      </section>
    </>
  );
};

export default MainContent;
